import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";
import { Reveal } from "@/components/Reveal";

/** Generic header used at the top of each standalone subpage. */
export const SubPageShell = ({ eyebrow, title, intro, children }) => (
  <div className="relative">
    <SiteNav />

    <section className="pt-32 md:pt-40 pb-2 md:pb-4">
      <div className="container-editorial">
        <Reveal>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[10px] tracking-[0.32em] uppercase text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--ink))] transition-colors mb-10"
          >
            <ArrowLeft size={14} strokeWidth={1.4} /> Back to Ata House
          </Link>
          <div className="eyebrow-rule">{eyebrow}</div>
          <h1 className="editorial-heading text-4xl md:text-5xl lg:text-6xl">
            {title}
          </h1>
          {intro && (
            <p className="mt-6 text-[hsl(var(--muted-foreground))] max-w-2xl">
              {intro}
            </p>
          )}
        </Reveal>
      </div>
    </section>

    {children}

    <SiteFooter />
  </div>
);
